import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import './UnSubscribeDedicatedNumberScss.scss'

const UnSubscribeDedicatedNumber = ({show, handleClose, Message, confirm}: any) => {
  const handleUnsubscribe = () => {
    confirm()
    handleClose()
  }
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <div className='modal-header text-center row'>
          <div className='icon-box col-12'>
            <i className='fa fa-exclamation-circle fa-5x' aria-hidden='true'></i>{' '}
          </div>
          <h2>Are you sure?</h2>
        </div>
        <div className='modal-body'>
          Do you really want to unsubscribe this number? This process cannot be undone.
        </div>
        <div className='modal-footer'>
          <Button color='secondary' onClick={handleClose}>
            Cancel
          </Button>{' '}
          <Button className='bg-danger' onClick={handleUnsubscribe}>
            Unsubscribe
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default UnSubscribeDedicatedNumber
